import { FormulaFields, BundleType } from 'services/store/ai/types';
import { AdvancedFormulaPromptData } from './types';

const getAdvancedPromptFormData = (
  payload: AdvancedFormulaPromptData
): FormData => {
  const formData = new FormData();
  formData.append('bundle_type', BundleType.ADVANCED);

  const { primaryGenre, microGenre, formula } = payload;
  const genre = microGenre ?? primaryGenre;

  formData.append('genre', genre);

  formula.forEach(({ field, value }) => {
    switch (field) {
      case FormulaFields.Instruments:
        Object.entries(value).forEach(([instrument, count]) => {
          for (let i = 0; i < count; i += 1) {
            formData.append('instruments[]', instrument);
          }
        });
        break;

      case FormulaFields.Key:
        formData.append('key_root', value.root);
        formData.append('key_quality', value.quality);
        break;

      case FormulaFields.UserLoop:
        formData.append('user_audio_id', value.loopId);
        formData.append('entropy', value.entropy.toString());
        break;

      default:
        if (value == null) {
          break;
        }
        formData.append(field, value.toString());
    }
  });

  return formData;
};

export default getAdvancedPromptFormData;
